import './ReportsApp.css'; // optional styles
import { AnalyticsDashboard } from './reports/AnalyticsDashboard';

const ReportsApp = () => {
  return (

      <AnalyticsDashboard />
   
  );
};

export default ReportsApp;


